import api from './client';
import type { RoleType, PageResponse } from '../types';

export interface GeneralNote {
  id: string;
  content: string;
  createdByUserId: string;
  createdByFirstName?: string | null;
  createdByLastName?: string | null;
  createdByRole?: RoleType | null;
  createdAt: string;
  updatedAt: string;
  embeddingPending: boolean;
}

export type NoteHitType = 'MACHINE' | 'GENERAL';

export interface NoteSearchHit {
  type: NoteHitType;
  noteId: string;
  machineId?: string | null;
  machineName?: string | null;
  snippet: string;
  content: string;
  score: number;
  createdAt: string;
  updatedAt: string;
  creator?: {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    role?: RoleType | null;
  } | null;
}

export const generalNotesApi = {
  list: (page = 0, size = 8) =>
    api.get<PageResponse<GeneralNote>>('/api/general-notes', { params: { page, size } }),
  create: (content: string) => api.post<GeneralNote>('/api/general-notes', { content }),
  update: (id: string, content: string) => api.put<GeneralNote>(`/api/general-notes/${id}`, { content }),
  delete: (id: string) => api.delete(`/api/general-notes/${id}`),
};

export const noteSearchApi = {
  search: (q: string) => api.get<NoteSearchHit[]>('/api/notes/search', { params: { q } }),
  summarize: (q: string) => api.get<{ summary: string | null }>('/api/notes/search/summary', { params: { q } }),
};
